var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBGgraphic4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 291,
    viewBox: "0 0 95 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.0859 170.5C54.6646 170.5 21.0859 136.921 21.0859 95.5C21.0859 54.0786 54.6646 20.5 96.0859 20.5",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 40
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0859 290.5C15.0859 273.931 28.7413 260.5 45.5859 260.5C62.4306 260.5 76.0859 273.931 76.0859 290.5",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 30
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBGgraphic4);
export default __webpack_public_path__ + "static/media/BGgraphic4.a4e9a1d688d5923beb098df2bcf17a46.svg";
export { ForwardRef as ReactComponent };